/**
 * @fileoverview GET handler for the "/internal_user_groups/anonymous_users" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsInternalUserGroupsAnonymousUsers } from "./constants";
import type {
  AppSettingsInternalUserGroupsAnonymousUsersProps,
  GetAppSettingsInternalUserGroupsAnonymousUsersResult,
} from "./types";

export const getAppSettingsInternalUserGroupsAnonymousUsers = reactQueryFetcherAdapter(
  appSettingsInternalUserGroupsAnonymousUsers,
  (
    signal: AbortSignal,
    props: AppSettingsInternalUserGroupsAnonymousUsersProps
  ): Promise<GetAppSettingsInternalUserGroupsAnonymousUsersResult> => {
    const params = {
      app_group_id: props.appGroupId,
      app_api_key: props.appApiKey,
      ip_address: props.ipAddress,
    };

    return fetch("/internal_user_groups/anonymous_users", "GET", params, { signal });
  }
);
